'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
import { getLightness } from "./getLightness.js";
const calibrateLight = (lightness, amount) => Math.max(0, Math.min(100, (100 - lightness) * amount));
const calibrateDark = (lightness, amount) => Math.max(0, Math.min(100, lightness * amount));
const getPrimaryPalette = (primaryColor, preset) => {
  const lightness = getLightness(primaryColor);
  const lightest = preset?.lightest ?? tinycolor(primaryColor).lighten(calibrateLight(lightness, 0.9)).toHexString();
  const light = preset?.light ?? tinycolor(primaryColor).lighten(calibrateLight(lightness, 0.75)).toHexString();
  const base = preset?.base ?? tinycolor(primaryColor).lighten(calibrateLight(lightness, 0.5)).toHexString();
  const dark = preset?.dark ?? tinycolor(primaryColor).toHexString();
  const darkest = preset?.darkest ?? tinycolor(primaryColor).darken(calibrateDark(lightness, 0.25)).toHexString();
  return {
    lightest,
    light,
    base,
    dark,
    darkest
  };
};
export {
  calibrateDark,
  calibrateLight,
  getPrimaryPalette
};
